(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/kyc/kyc.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/kyc/kyc.js');
'use strict';

const {
  useRef,
  useEffect
} = React;
const {
  useHistory
} = ReactRouterDOM;
const {
  routes
} = svs.myProfile.constants;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  defaultTechnicalErrorDialog
} = svs.myProfile.react.pages.kyc.dialogs;
const Kyc = () => {
  const [isKycLoaded, setIsKycLoaded] = React.useState(false);
  const kycContainerRef = useRef();
  const history = useHistory();
  const kycErrorCallback = async () => {
    await defaultTechnicalErrorDialog();
  };
  useEffect(() => {
    const onKycCancel = () => {
      history.push(routes.MY_PROFILE_HOME);
    };
    const navigateToQuestions = () => {
      history.push(routes.MY_PROFILE_KYC_QUESTIONS);
    };
    svs.core.module.load('/cl/components/react:kyc', null, () => {
      setIsKycLoaded(true);
      svs.components.kyc.init(kycContainerRef.current, {
        context: void 0,
        onComplete: navigateToQuestions,
        showOverview: true,
        onCancel: onKycCancel,
        onError: kycErrorCallback
      });
    }, false);
  }, [history]);
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, !isKycLoaded && React.createElement(React.Fragment, null, React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 11,
    boxWidthProcent: 100,
    topMargin: 3
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  }), React.createElement(Skeleton, {
    bottomMargin: 0,
    boxHeight: 6,
    boxWidthProcent: 100,
    topMargin: 1
  })), React.createElement("div", {
    className: "padding-top-2",
    ref: kycContainerRef
  }));
};
svs.myProfile.react.pages.kyc.Kyc = Kyc;

 })(window);